<template>
  <div class="scenic-list" v-show="show">
    <div class="scenic-list-header">
      <i class="el-icon-arrow-left" @click="hideScenic()"></i>
      <div class="text-center">行程定制</div>
      <i class="el-icon-search" @click="searchShow=true"></i>
    </div>
    <div class="scenic-list-content">
      <div class="scenic-list-content-type">
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          menu-trigger="click"
          mode="horizontal"
          :stretch="true"
          @select="handleSelect"
          :unique-opened="true"
        >
          <el-submenu index="1">
            <template slot="title">{{areaName}}</template>
            <el-menu-item v-bind:index="m.areaCode" v-for="(m,index) in areaList">{{m.name}}</el-menu-item>
          </el-submenu>
          <el-submenu index="2">
            <template slot="title">{{typeName}}</template>
            <el-menu-item index="全部类型">全部类型</el-menu-item>
            <el-menu-item index="专题文化">专题文化</el-menu-item>
            <el-menu-item index="自然景观">自然景观</el-menu-item>
          </el-submenu>
          <el-submenu index="3">
            <template slot="title">{{sortName}}</template>
            <el-menu-item index="默认排序">默认排序</el-menu-item>
            <el-menu-item index="按热度">按热度</el-menu-item>
          </el-submenu>
        </el-menu>
      </div>
      <div class="scenic-list-content-list clearfix">
        <scroller :on-refresh="refresh" :on-infinite="infinite" ref="myscroller">
          <ul>
            <li v-for="(item,i) in arr" :key="i" @click="selectEvent(item)">
              <div class="li-left">
                <img :src="item.imgUrl" />
                <span></span>
                <i :class="queryScenic(item)"></i>
              </div>
              <div class="li-right">
                <h5>{{item.destName}}</h5>
                <el-rate
                  v-model="value"
                  disabled
                  show-score
                  text-color="#ff9900"
                  score-template="{value}"
                ></el-rate>
                <!-- <span>{{item.destName}}</span> -->
                <p>地址:{{item.address}}</p>
              </div>
            </li>
          </ul>
        </scroller>
      </div>
    </div>
    <div class="scenic-list-search" v-show="searchShow">
      <el-input
        placeholder="请输入内容"
        type="search"
        v-model="input3"
        class="input-with-select"
        :clearable="true"
        :on-icon-click="pchandleIconClick"
        @keyup.enter.native="searchEnterFun"
      >
        <template slot="prepend">
          <i class="el-icon-search"></i>
        </template>
        <el-button slot="append" @click="searchEnterFun">搜索</el-button>
      </el-input>
    </div>
    <div class="scenic-list-footer" @click="confirmScenic()">确认</div>
  </div>
</template>

<script>
require("../../styles/travel/scenic-list-main.scss");
import { queryScenicList } from "../../actions/portal/protal";
import Vue from "vue";
import VueScroller from "vue-scroller";
import { setTimeout } from "timers";
import { debuglog } from "util";
export default {
  props: [
    "NAME",
    "show",
    "scenicList",
    "scenicCallBack",
    "showCallBack",
    "hideCallBack",
    "areaName",
    "areaList",
    "areaIds",
    "curDay",
    "hasAreaList"
  ],
  data() {
    return {
      msg: "行程规划主页面",
      dayMsg: "第一天",
      mydata: [{ text: "南山" }],
      activeName: "second",
      radio: "3",
      activeIndex: "1",
      noData: false,
      arr: [],
      page: 1,
      pageSize: 10,
      value: 3.7,
      searchShow: false,
      input3: "",
      scenics: [],
      typeName: "全部类型",
      sortName: "默认排序",
      areaId: "",
      areaLists: []
    };
  },
  mounted:function(){
    if(this.hasAreaList!=[]){
        this.areaLists=this.hasAreaList;
      }
  },
  methods: {
    reload() {
      this.scenics = this.scenicList;
      this.input3 = "";
      this.areaId = this.areaIds;
      
      this.getData();
    },
    handleSelect(key, keypath) {
      this.page = 1;
      this.getData();
      if (keypath[0] == "1") {
        this.areaId = key;
        var that = this;
        this.areaList.filter(o => {
          if (o.areaCode == that.areaId) {
            that.areaName = o.name;
            return;
          }
        });
      }
      if (keypath[0] == "2") {
        this.typeName = key;
      }
      if (keypath[0] == "3") {
        this.sortName = key;
      }
      console.log(key, keypath);
    },
    hideScenic() {
      if (this.hideCallBack) {
        this.hideCallBack();
      }
    },
    selectEvent(item) {
      var isExist = 0;
      if (this.areaLists[this.curDay - 1] == undefined) {
        this.areaLists[this.curDay - 1] = [];
      }
      var that = this;
      

      this.scenics = this.scenics.filter((o, index) => {
        if (o.destId === item.destId) {
          isExist = 1;
          that.areaLists[that.curDay - 1].splice(index, 1);
          console.log(index);
        } else {
          return o;
        }
      });
      if (isExist != 1 || this.scenics.length == 0) {
        this.scenics.push(item);
        this.areaLists[this.curDay - 1].push({
          areaCode: this.areaId,
          name: that.areaName,
          day: this.curDay
        });
      }
    },
    confirmScenic() {
      if (this.scenicCallBack) {
        this.scenicCallBack(this.scenics, this.areaLists);
      }
    },
    queryScenic(item) {
      var b = "";
      var a = this.scenics.filter(o => o.destId == item.destId);
      if (this.scenics.length === 0) {
        return "el-icon-circle-plus-outline";
      }
      if (a.length != 0) {
        return "el-icon-circle-check";
      } else {
        return "el-icon-circle-plus-outline";
      }
      // return b;
    },
    pchandleIconClick() {
      this.page = 1;
      this.arr = [];
      this.noData = false;
      this.searchShow = false;
      this.getData();
    },
    searchEnterFun() {
      this.page = 1;
      this.arr = [];
      this.noData = false;
      this.searchShow = false;
      this.getData();
    },
    getData() {
      var that = this;
      //         axios.get('/api/article/findArticleList',{params:{pageNum:that.page,pageSize:that.pageSize}})
      //  6 　　　　 .then(function(data){
      //  7
      // 17                      })
      queryScenicList({
        pageIndex: that.page,
        pageSize: that.pageSize,
        destName: that.input3
      }).then(res => {
        if (that.page === res.paging.totalPage) {
          that.noData = true;
        }
        if (that.page === 1) {
          that.arr = res.data;
        } else {
          that.arr = that.arr.concat(res.data);
        }
      });
    },
    //下拉刷新
    refresh() {
      this.page = 1; //重置页数
      this.noData = false;
      setTimeout(
        function() {
          this.getData();
          this.$refs.myscroller.finishPullToRefresh(); //刷新完毕关闭刷新的转圈圈
        }.bind(this),
        1700
      );
    },
    //上拉加载
    infinite(done) {
      if (this.noData) {
        this.$refs.myscroller.finishInfinite(true); //不让它加载，，显示“没有更多数据”，不然会一直转圈
      } else {
        setTimeout(() => {
          this.page++; //下拉一次页数+1
          this.getData();
          done(); //进行下一次加载操作
        }, 1500);
      }
    }
  }
};
Vue.use(VueScroller);
</script>

<style scoped>
</style>